'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxTabtext } from './Tabtext'
import { TabtextProps } from './Tabtext'

interface TabtextBlokProps {
  blok: {
    title: TabtextProps['title']
    subtitle: TabtextProps['subtitle']
    content: TabtextProps['content']
    reverse?: TabtextProps['reverse']
    tabs: any
    mobileReverse?: TabtextProps['mobileReverse']
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
  } & SbBlokData
}

const Tabtext: FC<TabtextBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)

  const [tabs, setTabs] = useState()

  useEffect(() => {
    if (blok.tabs) {
      const tabsArray = blok.tabs.map((tab: any) => {
        return {
          asset: {
            src: tab.asset?.filename,
            alt: tab.asset?.alt,
          },
          title: tab.title,
          content: tab.content,
        }
      })
      setTabs(tabsArray)
    }
  }, [blok.tabs])
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxTabtext
        title={blok.title}
        subtitle={blok.subtitle}
        content={blok.content}
        tabs={tabs}
        reverse={blok.reverse}
        mobileReverse={blok.mobileReverse}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
      />
    </div>
  )
}

export default Tabtext
